function scroll_to_top(){
    $('html, body').animate({
      scrollTop: $('.custom-page-container').offset().top
    }, 1000);
}

var update_url = function( title ) {
    var obj = { Title: title, Url: '#'+ title };
    history.pushState(obj, obj.Title, obj.Url);
}

var navigate_to_step = function (step, update_hash = true){
    if( step == '' ) {
        step = 'select-dimensions';
    }

    if( update_hash ){
        update_url( step );
    }

    $('.tab--content').hide();
    $(".tab-containes-content").find("[data-step='" + step + "']").show().addClass('active_tab--content');

    $('.steps-grid ul li, .mobile_tabs').removeClass('active-tabs');
    $("[data-step='" + step + "']").addClass('active-tabs');

    scroll_to_top();
}

$( document ).ready(function() {
  const create_product_url = 'https://rmshowerdoors.com/create_product.php';
  var unit_price = 0;
  var final_price = 0
  var quantity = 1;
  var item_weight = '0 lbs';
  var clear_glass_multiplier = 0.22;
  var multiplier_except_cg = 0.25;
  var argon_gas_multiplier = 0.024;
  var min_price = 181.81;
  var grid_options = "None";
  var grid_price = 0;
  var grid_option_multipler = 0.03;
  const settings = {"color_text":"#3a3a3a","color_body_text":"#333232","color_sale_text":"#EA0606","color_button":"#3a3a3a","color_button_text":"#ffffff","color_small_button_text_border":"#3a3a3a","color_text_field_text":"#000000","color_text_field_border":"#cccccc","color_text_field":"#ffffff","color_image_overlay_text":"#ffffff","color_image_overlay":"#685858","image_overlay_opacity":40,"color_borders":"#ebebeb","color_body_bg":"#ffffff","type_header_font":{"error":"json not allowed for this object"},"type_header_base_size":26,"type_base_font":{"error":"json not allowed for this object"},"type_base_size":15,"predictive_search_enabled":true,"predictive_search_show_vendor":true,"predictive_search_show_price":true,"share_facebook":true,"share_twitter":true,"share_pinterest":true,"social_twitter_link":"","social_facebook_link":"https:\/\/www.facebook.com\/royaltymirror","social_pinterest_link":"#","social_instagram_link":"https:\/\/www.instagram.com\/royaltymirror\/","social_tumblr_link":"","social_snapchat_link":"","social_youtube_link":"https:\/\/www.youtube.com\/@royaltymirror2460","social_vimeo_link":"","favicon":"\/\/cdn.shopify.com\/s\/files\/1\/0507\/2597\/8291\/files\/favicon-32x32.png?v=1787130233","enable_ajax":false,"business_address":"1688 Meridian Ave, Suit 700\nMiami Beach, FL 33139","contact_info_email":"support@royaltymirror.com","contact_info_phone":"\u003ca href=\"tel:8005826775\"\u003e(800) 582-6775\u003c\/a\u003e","insulated_glass_multiplier":"0.22","multiplier_except_clear_glass":"0.25","argon_gas_multiplier":"0.024","insulated_glass_min_price":"181.81","insulated_glass_price_above_1000":"0","insulated_glass_price_above_1200":"50","insulated_glass_price_above_1500":"80","insulated_glass_price_above_2000":"500","insulated_glass_price_above_2500":"700","insulated_glass_price_above_3000":"800","insulated_glass_price_above_3500":"950","insulated_glass_price_above_4000":"1300","insulated_glass_price_above_4500":"1500","insulated_glass_price_above_5000":"1000","insulated_glass_price_above_10000":"1000","default_3_x_3_price":"4.99","ultra_clear_glass_price":"60","gray_glass_price":"30","tint_bronze_glass_price":"30","frosted_glass_price":"50","black_glass_price":"50","custom_cut_glass_add_min_price":"7.57","custom_cut_glass_price_above_1000":"0","custom_cut_glass_price_above_1200":"90","custom_cut_glass_price_above_1500":"150","custom_cut_glass_price_above_2000":"500","custom_cut_glass_price_above_2500":"600","custom_cut_glass_price_above_3000":"700","custom_cut_glass_price_above_3500":"1200","custom_cut_glass_price_above_4000":"1800","custom_cut_glass_price_above_4500":"2000","custom_cut_glass_price_above_5000":"2500","custom_cut_glass_price_above_10000":"2700","custom_cut_glass_thickness_1_8":"0.168","custom_cut_glass_thickness_3_8":"0.230","custom_cut_glass_thickness_1_2":"0.250","custom_cut_glass_thickness_5_8":"0.700","default_mirror_3_x_3_price":"4.99","mirror_multiplier":"0.20","mirror_polish_multiplier":"0.35","mirror_min_price":"25.46","mirror_price_above_1000":"0","mirror_price_above_1200":"70","mirror_price_above_1500":"100","mirror_price_above_2000":"500","mirror_price_above_2500":"705","mirror_price_above_3000":"1000","mirror_price_above_3500":"2000","mirror_price_above_4000":"2000","mirror_price_above_4500":"2100","mirror_price_above_5000":"2100","mirror_price_above_10000":"2100","mirror_beveled_polished_edge_disabled":false,"beveled_edge_disabled":false,"beveled_polished_edge_disabled":false,"seamed_edge_disabled":false,"pencil_polished_edge_disabled":true,"hs_6in_most_popular_price":"0","hs_8in_most_popular_price":"36.00","hs_6in_square_handle_price":"25.00","hs_8in_square_handle_price":"35.00","hs_6in_ladder_handle_price":"55.00","hs_8in_ladder_handle_price":"75.00","hs_knob_handle_price":"40.00","hs_towel_bar_price":"75.00","hs_pull_handle_price":"75.00","matte_black_hardware_price":"170","brushed_nickel_hardware_price":"150","oil_rubbed_bronze_hardware_price":"200","polished_brass_hardware_price":"170","polished_chrome_hardware_price":"150","polished_nickel_hardware_price":"170","satin_brass_hardware_price":"170","shower_door_thickness_3_8":"0.30","shower_door_thickness_1_2":"0.35","glass_table_top_delivery_text":"7-10 Business Days","mirrors_delivery_text":"7-10 Business Days","replacement_glass_delivery_text":"7-10 Business Days","glass_shelves_delivery_text":"7-10 Business Days","laminated_glass_delivery_text":"7-10 Business Days","tempered_glass_delivery_text":"7-10 Business Days","insulated_glass_delivery_text":"7-10 Business Days","shower_doors_delivery_text":"7-15 Business Days","shop_pay_enabled":false,"shop_pay_text":"Pay in full or in 4 interest-free installments of {amount}","order_summary_additional_information":"Safe Delivery Guaranteed","order_summary_additional_information_2":"Order Now \u0026 Secure Your Production Spot!","custom_cut_glass_thickness_3_4":"0.700","mirror_price_above_60":"100","mirror_flat_polished_edge_disabled":false,"checkout_logo_image":"shopify:\/\/shop_images\/Newlogo-dark.png","checkout_accent_color":"#000000","checkout_button_color":"#ffd814","checkout_layout":"onepage","insulated_glass_additional_price":"500","customer_layout":"customer_area"};

  update_url('select-dimensions');

  window.onhashchange = function() {
    var hash = window.location.hash.substring(1); //Puts hash in variable, and removes the # character
    navigate_to_step( hash, false );
  }

  $(document).on('click', '.active-tabs-head, .mobile_tabs.active-tabs', function(){
    var step = $(this).data('step');
    update_url(step);
    navigate_to_step(step);
  });

  function calculate_price(){
      let length = $('.dim_length').val();
      let width = $('.dim_width').val();
      let area = length * width;

      let glass_type_outside = $('input[name=glass_types_outside]:checked').val();
      let glass_type_inside = $('input[name=glass_types_inside]:checked').val();
      let multiplier = clear_glass_multiplier;

      if( ( glass_type_outside != 'Clear' && glass_type_outside != 'Ultra Clear' ) || ( glass_type_inside != 'Clear' && glass_type_inside != 'Ultra Clear' ) ){
          multiplier = multiplier_except_cg;
      }

      const unitPrice = calculateUnitPrice(area, multiplier);
      unit_price = unitPrice.toFixed(2);
      final_price = ( unit_price * quantity ).toFixed(2);

      console.log("Final price: "+ final_price);

      $('.price__ok span').text("$"+ final_price)
      $('.price__ok .bp_thick_price').text("$"+ final_price);
      $('.total_cart .bp_thick_price').text("$"+ final_price);

      var installment_amount = (final_price / 4).toFixed(2);
      $('#installment_amount').text('$ ' + installment_amount);

      if( final_price > 3000 ){
        $('#installment_li').hide();
      }else{
         $('#installment_li').show();
      }
  }

  const calculateUnitPrice = (area, multiplier) => {
      let basePrice = area * multiplier;

      if( basePrice < min_price ){
          basePrice = min_price;
      }

      const aragonGasPrice = argon_gas_price();
      const gridOptionPrice = grid_option_price();
      const additionalPrice = getAdditionalPrice('insulated_glass', area, settings);

      console.log('Base Price', basePrice);
      console.log('Argon Gas Price', aragonGasPrice);
      console.log('Grid Option Price', gridOptionPrice);
      console.log('Additional Price', additionalPrice);

      let unitPrice = basePrice + aragonGasPrice + gridOptionPrice + additionalPrice;

      //Increase price by 10%
      unitPrice += (unitPrice * 10) / 100;

      console.log("Unit price: "+ unitPrice);
      return unitPrice;
  }

  $('input[name=add_argon_gas]').change(function(){
      calculate_price();
  });

  function argon_gas_price(){
      let price = 0;
      let add_argon_gas = $('input[name=add_argon_gas]:checked').val();

      if( add_argon_gas == 'Yes' ){
          let length = $('.dim_length').val();
          let width = $('.dim_width').val();
          let area = length * width;
          price = area * argon_gas_multiplier;
      }

      console.log("Argon gas price:" + price);
      return price;
  }

  function draw_grid(column_count, row_count){
      const table_width = 180;
      const table_height = 180;
      const col_width = table_width / column_count;
      const col_height = table_height / row_count;
      let dim_height_text = $('.dim_width').val();
      const dim_frac_height = $('.dim_frac_width').val();
      let dim_length_text = $('.dim_length').val();
      const dim_frac_length = $('.dim_frac_length').val();
      const table_style = `width:${table_width}px;height:${table_height}px;`;
      dim_length_text += `${dim_frac_length == '0' ? '' : dim_frac_length}"`;
      dim_height_text += `${dim_frac_height == '0' ? '' : dim_frac_height}"`;

      let row = 0;
      let col = 0;
      let grid = `<table style="${table_style}" align="center" border="1" class="table table-bordered-table-grid m-0">`;
      grid += `<span id="grid-pattern-width">Width: ${dim_length_text}</span>`;
      grid += `<span id="grid-pattern-height">Height: ${dim_height_text}</span>`;

      while(row < row_count){
        col = 0;
        grid += `<tr>`;
        while(col < column_count){
           grid += `<td style="width:${col_width}px; height:${col_height}px; border-color: #000000"></td>`;
           col++;
        }
        grid += `</tr>`;
        row++;
      }
      grid += `</table>`;

      return grid;
  }

  function grid_option_price(){
      let price = 0;
      let grid_option = $('input[name=add_grid_options]:checked').val();
      console.log(grid_option);

      if( grid_option != 'None' ){
          let length = $('.dim_length').val();
          let width = $('.dim_width').val();
          let area = length * width;
          price = area * grid_option_multipler;
      }

      console.log("Grid option price:" + price);
      return price;
  }

  function update_selected_grid_options(){
     const grid_option = $('input[name=add_grid_options]:checked').val();
     const grid_pattern_width = $('select[name=grid_pattern_width]').val();
     const grid_pattern_height = $('select[name=grid_pattern_height]').val();
     // const grid_dimensions = grid_pattern_width + "x" + grid_pattern_height;
     const grid_dimensions = `(W)${grid_pattern_width} x (H)${grid_pattern_height}`;
     let grid_color = "";
     let grid_options = "";

	 if( grid_option == 'None' ){
		$('#grid_options, #grid_pattern, .grid_color').addClass('d-none');
        grid_options = "None";
	 }else{
		$('#grid_options, #grid_pattern').removeClass('d-none');
		$('.grid_color').addClass('d-none');

		if( grid_option == '5/8" Grid' ){
			$('#grid_color_58').removeClass('d-none');
            grid_color = $('input[name=grid_color_58]:checked').val();
		}else{
			$('#grid_color_1').removeClass('d-none');
            grid_color = $('input[name=grid_color_1]:checked').val();
		}
        grid_options = `${grid_color} ${grid_option}: ${grid_dimensions}`;
	 }

     $('.selected_grid_options').text(grid_options);
  }

  function calculate_item_weight(w, h){
      // let thickness = $('input[name=select_overall_thickness]:checked').data('thickness');
      const thickness = 0.0117;
      console.log(`THickness ::: ${thickness}`);
      let weight = ( ( w * h ) * thickness ) * 2;
      item_weight = weight.toFixed(2) + ' lbs';
  }

  $('input[name=glass_thickness]').change(function(){
      glass_thickness_handler();
  });

  function glass_thickness_handler(){
    $('.thickness_img').addClass('d-none');
    const { showThickness, hideThickness, defaultThickness } = getThicknessOptionsToUpdate();
    toggleThicknessOptions(showThickness, false, defaultThickness);
    toggleThicknessOptions(hideThickness, true, defaultThickness);
  }

  // Determine which thickness options to show/hide based on the selected glass thickness
  const getThicknessOptionsToUpdate = () => {
    const glass_thickness = $('input[name=glass_thickness]:checked').val();
    let showThickness, hideThickness, defaultThickness;
  
    switch (glass_thickness) {
      case '1/4" Commercial use':
        $('#1_4_thickness_img').removeClass('d-none');
        showThickness = [];
        hideThickness = ['7/16', '1/2', '5/8'];
        defaultThickness = '9/16';
        break;
  
      case '3/16" Residential use':
        $('#3_16_thickness_img').removeClass('d-none');
        showThickness = ['5/8'];
        hideThickness = ['7/16', '1/2'];
        defaultThickness = '9/16';
        break;
  
      default:
        $('#1_8_thickness_img').removeClass('d-none');
        showThickness = ['7/16', '1/2', '5/8'];
        hideThickness = [];
        defaultThickness = '';
    }

    return { showThickness, hideThickness, defaultThickness };
  }

  const toggleThicknessOptions = (options, hide, defaultThickness) => {
    options.forEach(option => {
      const $element = $(`.overall_thickness input[value='${option}']`).closest('.__thickness');
      if (hide) {
        $element.addClass('d-none');
      } else {
        $element.removeClass('d-none');
      }
    });

    if (defaultThickness != '') {
      $(`.overall_thickness input[value='${defaultThickness}']`).prop("checked", true);
    } 
    
  }

  const initialize = () => {
    const imag = '//cdn.shopify.com/s/files/1/0507/2597/8291/files/insulatedGlass.svg?v=1762162177';
    const title = 'Rectangle';

    $('.rect_edge').show();
    $('.circle_edge').hide();
    $('.for_rect').show();
    $('.for_rounded').hide();
  
    $('#listOfDimensionValues206-text').html('Width (W) - Choose:');
    $('#listOfDimensionValues207-text').html('Height (H) - Choose:');

    $('.length-width').show();
    $('.diamerter').hide(); 
    $('.length2_width').hide();  
    $('.length3_width').hide();
    $('.edge').hide();
    $('.serface_leng_wid').hide();
    $('.length2_width_heigth').hide();
    $('.width2_height').hide();
    $('.edge_leng_wid').hide();
    $('.leng_width_edge2').hide();
    $('.radius').hide();
    $('.radiuscr').hide();
    $('.height_width_ww').hide();

    $('.seleted_imag').attr('src','https:'+ imag);
    $('.selected_shape').text(title);
    $('.selected_shape').val(title);
  }

  //demesion click

  $( ".continue__tab-2" ).click(function() {

    $( "input[name=select_hole]" ).each(function( index ) {
        $(this).prop('checked', false);

        if($(this).val() == "No Hole"){
            $(this).prop('checked', true);
        }
    });

    $('.step4').val(0);

    var title = $('.selected_shape').val();
    //const glassThickness = $('input[name=glass_thickness]:checked').val();
    const glassThickness = '1/8" Residential use';
    $('.selected_thickness').text(glassThickness);

    if(title == "Rectangle"){
        var first_val = $('#listOfDimensionValues206').val();
        var second_val = $('#listOfDimensionFractions_206').val();
        var third_val = $('#listOfDimensionValues207').val();
        var fourth_val = $('#listOfDimensionFractions_207').val();
        var maxh = first_val;
        var maxw = third_val;

        $('.desmino_mas').text('(W)'+first_val+'"'+second_val+'" X (H)'+third_val+'" '+fourth_val+'" ');
        $('.dim_length').val(first_val);
        $('.dim_frac_length').val(second_val);
        $('.dim_width').val(third_val);
        $('.dim_frac_width').val(fourth_val);
        var x = parseFloat(first_val) * parseFloat(third_val);  
        $('.total_inch_space').val(x);

        if(x <= 399){
          var adding_value = parseFloat(0.17);
          var final_val = '69.99';
        }else if(x >= 400){
          var adding_value = parseFloat(0.153);
          var final_val = parseFloat(x) * parseFloat(0.153);        
        }
        $('.adding_value').val(adding_value);
        $('.step1').val(final_val);

    }else if(title == "Arch"){
        var first_val = $('#listOfDimensionValues206').val();
        var second_val = $('#listOfDimensionFractions_206').val();
        var third_val = $('#listOfDimensionValues207').val();
        var fourth_val = $('#listOfDimensionFractions_207').val();

        var maxw = first_val;
        var maxh = third_val;

        $('.desmino_mas').text('(D)'+first_val+'"'+second_val+'" X (H)'+third_val+'" '+fourth_val+'" ');

        $('.dim_length').val(first_val);
        $('.dim_frac_length').val(second_val);
        $('.dim_width').val(third_val);
        $('.dim_frac_width').val(fourth_val);
        var x = 0.7854 * parseFloat(first_val) * parseFloat(third_val);
        $('.total_inch_space').val(x);

        if(x <= 399){
          var adding_value = parseFloat(0.17);
          var final_val = '69.99';
        }else if(x >= 400){
          var adding_value = parseFloat(0.153);
          var final_val = parseFloat(x) * parseFloat(0.153);        
        }

        $('.adding_value').val(adding_value);
        $('.step1').val(final_val);
    }else if(title == "Left Slope Rectangle" || title == "House"){
      const first_val = $('#listOfDimensionValues2061').val();
      const second_val = $('.lefts').val();
      const third_val = $('#listOfDimensionValues306').val();
      const fourth_val = $('.lefts1').val();
      const fifth = $('#listOfDimensionValues2071').val();
      const sixth = $('.lefts2').val();

      var maxh = first_val;
      var maxw = fifth;

      $('.desmino_mas').text('(H)'+first_val+'"'+second_val+'" X (H1)'+third_val+'" '+fourth_val+'"(W)'+fifth+'"'+sixth+'"');
      $('.dim_length').val(first_val);
      $('.dim_frac_length').val(second_val);
      $('.dim_width').val(fifth);
      $('.dim_frac_width').val(sixth);      

      var x = parseFloat(maxh) * parseFloat(maxw)
      $('.total_inch_space').val(x);

      if(x <= 399){
        var adding_value = parseFloat(0.17);
        var final_val = '69.99';
      }else if(x >= 400){
        var adding_value = parseFloat(0.153);
        var final_val = parseFloat(x) * parseFloat(0.153);        
      }
  
      $('.adding_value').val(adding_value);
      $('.step1').val(final_val);

    }else if(title == "Arch Top"){
      var first_val = $('#listOfDimensionValues2061').val();
      var second_val = $('.archtop').val();
      var third_val = $('#listOfDimensionValues306').val();
      var fourth_val = $('.archtop1').val();
      var fifth = $('#listOfDimensionValues2071').val();
      var sixth = $('.archtop2').val();

      var maxh = first_val;
      var maxw = fifth;
      
      $('.desmino_mas').text('(H)'+first_val+'"'+second_val+'"(H1)'+third_val+'"'+fourth_val+'"(W)'+fifth+'"'+sixth+'"');
      $('.dim_length').val(first_val);
      $('.dim_frac_length').val(second_val);
      $('.dim_width').val(fifth);
      $('.dim_frac_width').val(sixth);

      var x = parseFloat(maxh) * parseFloat(maxw);
      $('.total_inch_space').val(x);

      if(x <= 399){
        var adding_value = parseFloat(0.17);
        var final_val = '69.99';

      }else if(x >= 400){
        var adding_value = parseFloat(0.153);
        var final_val = parseFloat(x) * parseFloat(0.153);        
      }
      $('.adding_value').val(adding_value);
      $('.step1').val(final_val);

    }else{
      var first_val = $('#listOfDimensionValues206').val();
      var second_val = $('#listOfDimensionFractions_206').val();
      var third_val = $('#listOfDimensionValues207').val();
      var fourth_val = $('#listOfDimensionFractions_207').val();

      var maxh = first_val;
      var maxw = third_val;
      
      $('.desmino_mas').text('(H)'+first_val+'"'+second_val+'" X (W)'+third_val+'" '+fourth_val+'" ');
      $('.dim_length').val(first_val);
      $('.dim_frac_length').val(second_val);
      $('.dim_width').val(third_val);
      $('.dim_frac_width').val(fourth_val);
      var x = parseFloat(first_val) * parseFloat(third_val);
      var y = parseFloat(x) / 144;
      $('.total_inch_space').val(x);
 
      if(x <= 399){
        var adding_value = parseFloat(0.17);
        var final_val = '69.99';


      }else if(x >= 400){
        var adding_value = parseFloat(0.153);
        var final_val = parseFloat(x) * parseFloat(0.153);        
      }
      $('.adding_value').val(adding_value);
      $('.step1').val(final_val);
    }

    console.log("Width: "+ maxw + ", height:" + maxh);

    //glass_thickness_handler();
    calculate_item_weight(maxw, maxh);
    calculate_price();
    update_url("select-glass-type");
  });

  $(".step-1-back").click(function() {
      $("#mob_tab_3").css("display", "none");
      $(".mob_tab3").css("display", "none");
      $("#mob_tab_2").css("display", "block");
      $(".mob_tab2").css("display", "block");
      $('[data-tab="tab-2"]').addClass('active-tabs');
      $('[data-tab="tab-3"]').removeClass('active-tabs');
      update_url("select-dimensions");
  });

  $( ".continue__tab-3" ).click(function() {
    $( "input[name=select_hole]" ).each(function( index ) {
      $(this).prop('checked', false);

      if($(this).val() == "No Hole"){
        $(this).prop('checked', true);
      }
    });

    $('.step3').val('20');

    var value = $('input[name=glass_types_inside]:checked').attr('data-price');
    $('.selected_type_inside').text($('input[name=glass_types_inside]:checked').val());
    $('.selected_type_outside').text($('input[name=glass_types_outside]:checked').val());
    var get = $('input[name=glass_types]:checked').val();  

    if(get == "Clear Glass"){
      var price= "0";
    }else{
      var price= "50";
    }
    
    if(get == "Tint Bronze Glass" || get == "Black Glass"){
        $('.__thickness:not(.one_fourth,.three_eighth)').addClass('hidden');
    }else{
    	$('.__thickness').removeClass('hidden');
    }

    calculate_price();
    update_url("select-thickness-strength");
  }); 

  $(".step-2-back").click(function() {
    $("#mob_tab_4").css("display", "none");
    $(".mob_tab4").css("display", "none");
    $("#mob_tab_3").css("display", "block");
    $(".mob_tab3").css("display", "block");
    $('[data-tab="tab-3"]').addClass('active-tabs');
    $('[data-tab="tab-4"]').removeClass('active-tabs');
    update_url("select-glass-type");
  });

  $( "#listOfDimensionValues206").change(function() {
    var val = $(this).val();
    var title = $('.selected_shape').val();
    if(title == "Square" || title == "Semi Circle"){
      $('#listOfDimensionValues207 option[value='+val+']').attr('selected','selected');
    }

    redraw_grid();
  });

  $( "#listOfDimensionValues207").change(function() {
    var val = $(this).val();
    var title = $('.selected_shape').val();
    if(title == "Square" || title == "Semi Circle"){
      $('#listOfDimensionValues206 option[value='+val+']').attr('selected','selected');
    }

    redraw_grid();
  });

  $('.select_shape').click(function() {
    navigate_to_step('select-shape');
  });

  $('.select_demis').click(function() {
    navigate_to_step('select-dimensions');

  });
  $('.select_lens').click(function() {
    navigate_to_step('select-glass-type');
  });

  $('.select_thickness').click(function() {
    navigate_to_step('select-thickness-strength');
  });

  $('.select_spacer, .select_argon_gas, .select_grid_options').click(function() {
    navigate_to_step('select-spacer');
  });

  $('#num1').click(function() {
    $('.step5').val('0');
    $('.step3').val('0');
    if($(".active-tabs-head").length){
      $('.tab--content[data-tab="tab-1"]').fadeIn().siblings().fadeOut();
      $('.steps-grid>ul>li[data-tab="tab-1"]').addClass("active-tabs").siblings().removeClass("active-tabs");
    }
  });

  $('#num2').click(function() {
    $('.step5').val('0');
    $('.step3').val('0');
    if($(".active-tabs-head").length){
      $('.tab--content[data-tab="tab-2"]').fadeIn().siblings().fadeOut();
      $('.steps-grid>ul>li[data-tab="tab-2"]').addClass("active-tabs").siblings().removeClass("active-tabs");
    }
  });

  $('#num3').click(function() {
    $('.step5').val('0');
    $('.step3').val('0');
    if($(".active-tabs-head").length>2){
      $('.tab--content[data-tab="tab-3"]').fadeIn().siblings().fadeOut();
      $('.steps-grid>ul>li[data-tab="tab-3"]').addClass("active-tabs").siblings().removeClass("active-tabs");
    }
  });

  $('#num4').click(function() {
    $('.step5').val('0');
    $('.step3').val('0');
    if($(".active-tabs-head").length>3){
      $('.tab--content[data-tab="tab-4"]').fadeIn().siblings().fadeOut();
      $('.steps-grid>ul>li[data-tab="tab-4"]').addClass("active-tabs").siblings().removeClass("active-tabs");
    }
  });

  $('#num5').click(function() {
    $('.step5').val('0');
    $('.step3').val('0');
    if($(".active-tabs-head").length>4){
      $('.tab--content[data-tab="tab-5"]').fadeIn().siblings().fadeOut();
      $('.steps-grid>ul>li[data-tab="tab-5"]').addClass("active-tabs").siblings().removeClass("active-tabs");
    }
  });

  $('#num6').click(function() {
    if($(".active-tabs-head").length>5){
      $('.tab--content[data-tab="tab-6"]').fadeIn().siblings().fadeOut();
      $('.steps-grid>ul>li[data-tab="tab-6"]').addClass("active-tabs").siblings().removeClass("active-tabs");
    }
  });
  $('#num7').click(function() {
    if($(".active-tabs-head").length>6){
      $('.tab--content[data-tab="tab-7"]').fadeIn().siblings().fadeOut();
      $('.steps-grid>ul>li[data-tab="tab-7"]').addClass("active-tabs").siblings().removeClass("active-tabs");
    }
  });

  $('#qty_minus_btn').click(function(){
      var qty = parseInt($('#quantity').val());
      if( qty > 1 ){
          qty--;
      }
      quantity = qty;
      $('#quantity').val(qty);
      calculate_price();
  });

  $('#qty_plus_btn').click(function(){
      var qty = parseInt($('#quantity').val());
      qty++;
      quantity = qty;
      $('#quantity').val(qty);
      calculate_price();
  });

  $('input[name=glass_types_outside]').change(function(){
      calculate_price();
  });

  $('input[name=glass_types_inside]').change(function(){
      calculate_price();
  });

  var get_properties = function(){
    const properties = {
        'Shape': $('#selected_shape').text(),
        'Dimensions': $('#selected_dimension').text(),
        'Thickness': $('#selected_thickness').text(),
        'Weight': item_weight,
        'Glass Type - Outside': $('#selected_type_outside').text(),
        'Glass Type - Inside': $('#selected_type_inside').text(),
        "Overall Thickness": $('#selected_overall_thickness').text(),
        "Glass Strength": $('#selected_strength').text(),
        "Glass Spacer":  $('#selected_spacer').text(),
        "Add Argon Gas":  $('#selected_argon_gas').text(),
        "Add Grid Options":  $('#selected_grid_options').text()
    };
    return properties;
  }

  $('#add_to_cart').click(function () {
        $(this).addClass('loading');
        const properties = get_properties();
        const data = {
            title: 'Insulated Glass',
            price: unit_price,
            properties: properties
        };
        const params = {
            type: 'POST',
            url: createShopifyProductUrl,
            data: data,
            dataType: "json"
        };

        $.ajax(params)
        .done(
            function(response) {
                var id = response.product.variants[0].id;
                var product_id = response.product.id;

                //Product created using shopify admin api.. add to cart it now.
                addToCart(id, properties);
          }.bind(this)
        )
        .fail(
            function(response) {
              console.log(response);
            }.bind(this)
        );
    });

  $('input[name=select_thickness]').click(function(){
    var change = $('input[name=select_thickness]:checked').val();
    var width = $('.dim_length').val();
    var heigth = $('.dim_width').val();

    var total_space = $('.total_inch_space').val();

    if(total_space <= 400){
      if(change == "1/8"){
        var efdsf = total_space * parseFloat(0.148);
        var final_value = parseFloat(efdsf) + 69.99;
      }else if(change == "5/32"){
        var efdsf = total_space * parseFloat(0.147);
        var final_value = parseFloat(efdsf) + 69.99;
      }else if(change == "3/16"){
        var efdsf = total_space * parseFloat(0.146);
        var final_value = parseFloat(efdsf) + 69.99;
      }else if(change == "1/4"){
        var val = $('.adding_value').val();
        var final_value = '69.99';
      }else if(change == "3/8"){
        var efdsf = total_space * parseFloat(0.195);
        var final_value = parseFloat(efdsf) + 69.99;
      }else if(change == "1/2"){
        var efdsf = total_space * parseFloat(0.21);
        var final_value = parseFloat(efdsf) + 69.99;
      }else if(change == "3/4"){
        var efdsf = total_space * parseFloat(0.807);
        var final_value = parseFloat(efdsf) + 69.99;
      }

      $('.step1').val(final_value);
    }

    if(total_space > 400){
      if(change == "1/8"){
        var final_value = total_space * parseFloat(0.148);
      }else if(change == "5/32"){
        var final_value = total_space * parseFloat(0.147);
      }else if(change == "3/16"){
        var final_value = total_space * parseFloat(0.146);
      }else if(change == "1/4"){
        var val = $('.adding_value').val();
        var final_value = total_space * parseFloat(val);
      }else if(change == "3/8"){
        var final_value = total_space * parseFloat(0.195);
      }else if(change == "1/2"){
        var final_value = total_space * parseFloat(0.21);
      }else if(change == "3/4"){
        var final_value = total_space * parseFloat(0.807);
      }
      console.log(final_value);
      $('.step1').val(final_value);
    }
  });

  $('input[name=select_thickness-1]').click(function(){

    var total_space = $('.total_inch_space').val();

    if(total_space > 0){
      if($('input[name=select_thickness-1]:checked').val() == "Tempered Glass"){
        var final_value = total_space * parseFloat(0.0139);
        //var get_val = parseFloat($('.step1').val()) + parseFloat(final_value);
        var get_val = '20';
      }else{
        var final_value = total_space * parseFloat(0.0139);
        //var get_val = parseFloat($('.step1').val()) - parseFloat(final_value);
        var get_val = '0';
      }      
      $('.step3').val(get_val);

    }
  });

  $('input[name=select_hole]').change(function(){
    var change = $('input[name=select_hole]:checked').val();

    if(change == "Center Hole (Umbrella Hole)"){
      $('.step4').val('10');
    }else{
      $('.step4').val('0');
    }
  });

  $( ".continue__tab-4" ).click(function() {
    var thickness =   $( "input[name=select_overall_thickness]:checked").val();
    var strength = $( "input[name=select_strength]:checked").val();
    var holee = '';

    var total_space = $('.total_inch_space').val();
    if($('input[name=select_thickness-1]:checked').val() == "Tempered Glass"){
      var final_value = total_space * parseFloat(0.0139);
      //var get_val = parseFloat($('.step1').val()) + parseFloat(final_value);
      var get_val = '20';
    }else{
      var final_value = total_space * parseFloat(0.0139);
      //var get_val = parseFloat($('.step1').val()) - parseFloat(final_value);
      var get_val = '0';
    }      
    $('.step3').val(get_val);    
    //$('.step3').val(final_value);
    var total_space = $('.total_inch_space').val();
    var change = thickness;
    if(change == "1/8"){
      var final_value = total_space * parseFloat(0.148);
    }else if(change == "5/32"){
      var final_value = total_space * parseFloat(0.147);
    }else if(change == "3/16"){
      var final_value = total_space * parseFloat(0.146);
    }else if(change == "1/4"){
      var val = $('.adding_value').val();
      var final_value = total_space * parseFloat(val);
    }else if(change == "3/8"){
      var final_value = total_space * parseFloat(0.195);
    }else if(change == "1/2"){
      var final_value = total_space * parseFloat(0.21);
    }else if(change == "3/4"){
      var final_value = total_space * parseFloat(0.807);
    }

    var total_space = $('.total_inch_space').val();

    if(total_space <= 400){
      if(change == "1/8"){
        var efdsf = total_space * parseFloat(0.148);
        var final_value = parseFloat(efdsf) + 69.99;
      }else if(change == "5/32"){
        var efdsf = total_space * parseFloat(0.147);
        var final_value = parseFloat(efdsf) + 69.99;
      }else if(change == "3/16"){
        var efdsf = total_space * parseFloat(0.146);
        var final_value = parseFloat(efdsf) + 69.99;
      }else if(change == "1/4"){
        var val = $('.adding_value').val();
        var final_value = '69.99';
      }else if(change == "3/8"){
        var efdsf = total_space * parseFloat(0.195);
        var final_value = parseFloat(efdsf) + 69.99;
      }else if(change == "1/2"){
        var efdsf = total_space * parseFloat(0.21);
        var final_value = parseFloat(efdsf) + 69.99;
      }else if(change == "3/4"){
        var efdsf = total_space * parseFloat(0.807);
        var final_value = parseFloat(efdsf) + 69.99;
      }

      $('.step1').val(final_value);
    }

    if(total_space > 400){

      if(change == "1/8"){
        var final_value = total_space * parseFloat(0.148);
      }else if(change == "5/32"){
        var final_value = total_space * parseFloat(0.147);
      }else if(change == "3/16"){
        var final_value = total_space * parseFloat(0.146);
      }else if(change == "1/4"){
        var val = $('.adding_value').val();
        var final_value = total_space * parseFloat(val);
      }else if(change == "3/8"){
        var final_value = total_space * parseFloat(0.195);
      }else if(change == "1/2"){
        var final_value = total_space * parseFloat(0.21);
      }else if(change == "3/4"){
        var final_value = total_space * parseFloat(0.807);
      }
      console.log(`Final value: ${final_value}`);
      $('.step1').val(final_value);
    }

    $('.step1').val(final_value);

    $('.glass_overall_thickness').text( thickness + '"' );
    $('.selected_overall_thickness').text( thickness + '"' );
    $('.selected_strength').text( strength );
    redraw_grid();
    update_url("select-spacer");
  });

  $(".step-3-back").click(function() {
      $("#mob_tab_5").css("display", "none");
      $(".mob_tab5").css("display", "none");
      $("#mob_tab_4").css("display", "block");
      $(".mob_tab4").css("display", "block");
      $('[data-tab="tab-4"]').addClass('active-tabs');
      $('[data-tab="tab-5"]').removeClass('active-tabs');
      update_url("select-thickness-strength");
  });

  $( ".continue__tab-5" ).click(function() {
    var value = $('input[name=select_spacer]:checked').attr('data-type');
    var title = $('input[name=select_spacer]:checked').val();
    $('.step5').val(value);
    $('.selected_spacer').text(title);

    let gas = $('input[name=add_argon_gas]:checked').val();
    $('.selected_argon_gas').text(gas);
    update_selected_grid_options();
    calculate_price();
    update_url("order-summary");
  });

  $('input[name=add_grid_options]').change(function(){
	const grid_option = $('input[name=add_grid_options]:checked').val();

	if( grid_option == 'None' ){
		$('#grid_options, #grid_pattern, .grid_color').addClass('d-none');
	}else{
		$('#grid_options, #grid_pattern').removeClass('d-none');
		$('.grid_color').addClass('d-none');

		if( grid_option == '5/8" Grid' ){
			$('#grid_color_58').removeClass('d-none');
		}else{
			$('#grid_color_1').removeClass('d-none');
		}
	}

    redraw_grid();
    calculate_price();
  });

  $("#grid_pattern select").change(()=>{
      redraw_grid();
  });

  const redraw_grid = () => {
      const grid_option = $('input[name=add_grid_options]:checked').val();
      const grid_pattern_width = parseInt($('select[name=grid_pattern_width]').val());
      const grid_pattern_height = parseInt($('select[name=grid_pattern_height]').val());
      let grid = "";

      if( grid_option != 'None' ){
          grid = draw_grid(grid_pattern_width, grid_pattern_height);
      }

      $('.grid-select').html(grid);
  }

  initialize();
});

$(document).ready(function(){
  
  $('#num1, #num6, .continue__tab-5.span_btn').click(function(){
    $('.mobile_bottom_mirror').removeClass('active');
  });
  
   $('.selection, .continue__tab-2.span_btn, .continue__tab-3.span_btn, .continue__tab-4.span_btn, .active-tabs-head').click(function(){
    $('.mobile_bottom_mirror').addClass('active');
  });
  
  $("#num2.active-tabs-head, #num3.active-tabs-head, #num4.active-tabs-head, #num5.active-tabs-head").click(function(){
    $('.mobile_bottom_mirror').addClass('active');
  });
  
  $(".active-tabs ~ .mobile_tabs").click(function(){
    $('.mobile_bottom_mirror').addClass('active');
  });

  $(".active-tabs ~ .mob_tab6.mobile_tabs").click(function(){
    $('.mobile_bottom_mirror').removeClass('active');
  });

  $('#customer_information_form').submit(function(e){

      	e.preventDefault();

    	var url = 'https://rmshowerdoors.com/send-email.php';
      	var btn = $('#shower-doors-submit-btn');
      	btn.addClass('loading');
      	$('.shower_ajax_response').hide();

      	var form_data = $(this).serializeArray();

        form_data.push({ name: "send-insulated-glass-email", value: 1 });
      	form_data.push({ name: "glass_shape", value: $('#selected_shape').text() });
        form_data.push({ name: "glass_dimension", value: $('#selected_dimension').text() });
        form_data.push({ name: "glass_thickness", value: $('#selected_thickness').text() });
        form_data.push({ name: "glass_type_inside", value: $('#selected_type_inside').text() });
        form_data.push({ name: "glass_type_outside", value: $('#selected_type_outside').text() });
        form_data.push({ name: "glass_overall_thickness", value: $('#selected_overall_thickness').text() });
        form_data.push({ name: "glass_strength", value: $('#selected_strength').text() });
    	  form_data.push({ name: "glass_spacer", value: $('#selected_spacer').text() });
      	form_data.push({ name: "quantity", value: $('#quantity').val() });

      	var params = {
          type: 'POST',
          url: url,         
          processData: false,
          dataType: 'html',
          data:  $.param(form_data),
        };
      	$.post(params)
          .done(
            function(response) {
			btn.removeClass('loading');
              $("#customer_information_form")[0].reset();
              $('.shower_ajax_response, #shower_ajax_success').show();
            }.bind(this)
          )
          .fail(
            function(response) {
              btn.removeClass('loading');
              $('.shower_ajax_response, #shower_ajax_error').show();
            }.bind(this)
          );
    });
  
});